import { useEffect, useState } from "react";
import { useAppSelector } from "../../../store";
import { storedLocale } from "../../Authentication/util";
import { useGetWhosNewQuery } from "../../../services/ActionReports/ActionReportAPI";
import type { WhosNewResponse } from "../../../services/ActionReports/ActionReportAPI.types";
import { useWatchlistFetch } from "../hooks/useWatchlistFetch";

export const defaultWhosNewActionReportData = (): WhosNewResponse => {
  return {
    Whosnew: [],
    Error: null,
    CallResults: [],
  };
};

export const FetchWhosNewActionReportData = (period: string, skipRequest = false) => {
  const { user } = useAppSelector((state) => state.boot);

  const {
    data: payloadData,
    isFetching,
    isError,
    refetch,
  } = useGetWhosNewQuery(
    {
      Aff: user.aff,
      Abo: user.abo,
      Period: period,
      Locale: storedLocale(),
    },
    {
      skip: skipRequest,
    },
  );

  const { isLoading: isLoadingWatchlist } = useWatchlistFetch();

  const [isLoading, setIsLoading] = useState(true);
  const [errorStatus, setErrorStatus] = useState(false);
  const [whosNewActionReportData, setWhosNewActionReportData] = useState<WhosNewResponse>(
    defaultWhosNewActionReportData(),
  );

  useEffect(() => {
    // Only stop loading when both report data AND watchlist are ready
    setIsLoading(isFetching || isLoadingWatchlist);
    setErrorStatus(isError);

    if (!isFetching && !isError && payloadData) {
      setWhosNewActionReportData({ ...defaultWhosNewActionReportData(), ...payloadData });
    }
  }, [isFetching, period, isError, payloadData, isLoadingWatchlist]);

  return { isLoading, whosNewActionReportData, errorStatus, refetch };
};
